import { PurlFormState, SendReferralFormState } from "src/app/angular-elements/form-wrappers/purl-form/interfaces/purl.interface";
import { ApplicationRecord } from "../../interfaces/application-record.interface";
import { SAVE_QUOTE_CARD_TYPE } from "./saved-quotes.input.interface";
import { BaseAgency } from "@ptl/account-management/types/ptl-account-management";
import { County } from "@ptl/global-components/types/ptl-global-components";
import { PRODUCT_GROUPS } from "src/app/angular-elements/plan-selection/enums/product-groups.enum";
import { Product } from "src/app/angular-elements/plan-selection/interfaces/product.interface";
import { PlanAttributes, SummaryView } from "src/app/angular-elements/plan-selection/interfaces/plan-attributes.interface";

export enum CONTENT_KEYS {
  PRODUCER_URL_PATH_CONTENT = "PRODUCER_URL_PATH_CONTENT"
}

export enum PRODUCER_URL_PATH_CONTENT_KEYS {
  URLS = "URLS"
}

export interface ExactTargetResponse {
  baseMessage: {
    uuid: string,
    returnCode: number,
    returnCodeDescription: string
  },
  payload: {
    messageSent: boolean,
    referralId: string
  }
}

export interface SaveQuoteEmailReferralModalArgs {
  applicationRecord: ApplicationRecord,
  quoteType: SAVE_QUOTE_CARD_TYPE,
  consumerDocumentUploadReturnUrl: string,
  defaultFieldData: {
    emailSuccessStatusMessage: string,
    emailFieldLabel: string,
    emailFieldPlaceholder: string,
    nameFieldLabel: string,
    nameFieldPlaceholder: string,
    agentNotesFieldLabel: string,
    agentNotesFieldPlaceholder: string
  }
  additionalModalFields: ModalFieldConfigs[];
}

export interface SaveQuoteDataSendReferralFormState {
  customerEmailAddress: string,
  clientName?: string, 
  agency?: string,
  agencyNumber?: string | number,
  npn?: string | number,
  zipCode?: string | number,
  county?: string,
  state?: string,
  agentNotes?: string
}

export enum EMAIL_REFERRAL_FORM_FIELD_LABELS {
  ['clientName'] = 'Client Name',
  ['agency'] = 'Agency',
  ['agencyNumber'] = 'Agency Number',
  ['npn'] = 'National Producer Number (NPN)',
  ['zipCode'] = 'Zip Code',
  ['county'] = 'County',
  ['state'] = 'State',
  ['agentNotes'] = 'Agent Notes'
}

export enum EMAIL_REFERRAL_FORM_CONTROL_VALUES {
  CLIENT_NAME = 'clientName',
  AGENCY = 'agency',
  AGENCY_NUMBER = 'agencyNumber',
  NPN = 'npn',
  ZIP_CODE = 'zipCode',
  COUNTY = 'county',
  STATE = 'state',
  AGENT_NOTES = 'agentNotes'
}
export interface ModalFieldConfigs {
  fieldName: string,
  display: string | boolean, 
  label: string,
  placeholder: string
}